// import React from "react";
// import { Box, Container, Grid, Paper, Typography, Button } from "@mui/material";
// import {
//     People, TrendingUp, Analytics, VideoLibrary, Campaign, Search,
//     Create, BarChart, Group, Web, ThumbUp, Share, QuestionAnswer,
//     RocketLaunch, Assessment
// } from "@mui-icons-material";

// // --- Data for the page sections ---
// const servicesList = [
//     { title: "Social Media Management", description: "Complete management of your social media profiles.", icon: <People /> },
//     { title: "SEO Optimization", description: "Improve your search engine rankings and visibility.", icon: <TrendingUp /> },
//     { title: "Content Creation", description: "Engaging video, graphic, and written content.", icon: <VideoLibrary /> },
//     { title: "Analytics & Reporting", description: "Detailed performance insights and reports.", icon: <Analytics /> },
//     { title: "Advertising Campaigns", description: "Targeted social media advertising strategies.", icon: <Campaign /> },
//     { title: "Keyword Research", description: "Strategic keyword analysis to find your audience.", icon: <Search /> },
//     { title: "Content Strategy", description: "Strategic content planning for maximum impact.", icon: <Create /> },
//     { title: "Performance Metrics", description: "Comprehensive analytics tracking and KPIs.", icon: <BarChart /> },
//     { title: "Community Management", description: "Engage, grow, and nurture your audience.", icon: <Group /> },
//     { title: "Website Optimization", description: "Technical SEO improvements for better performance.", icon: <Web /> },
//     { title: "Engagement Boost", description: "Increase audience interaction and loyalty.", icon: <ThumbUp /> },
//     { title: "Social Sharing", description: "Maximize your content's reach and virality.", icon: <Share /> },
// ];

// const processSteps = [
//     { title: "1. Consultation", description: "We start by understanding your brand, goals, and target audience.", icon: <QuestionAnswer /> },
//     { title: "2. Strategy", description: "Next, we develop a custom strategy tailored to your unique needs.", icon: <RocketLaunch /> },
//     { title: "3. Execution & Reporting", description: "We execute the plan and provide transparent reports on our progress.", icon: <Assessment /> },
// ];


// // --- The Main Component ---
// const Services = () => {
//     return (
//         <Box sx={{ backgroundColor: "#f4f6f8", py: { xs: 4, md: 8 } }}>
//             <Container maxWidth="lg">

//                 {/* --- Hero Section --- */}
//                 <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
//                     <Typography variant="h2" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>
//                         Our Services
//                     </Typography>
//                     <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto' }}>
//                         We offer a comprehensive suite of digital marketing services designed to elevate your brand's online presence and drive measurable results.
//                     </Typography>
//                 </Box>

//                 {/* --- Services Grid --- */}
//                 <Grid container spacing={3} sx={{ mb: { xs: 6, md: 10 } }}>
//                     {servicesList.map((service) => (
//                         <Grid item xs={12} sm={6} md={3} key={service.title}>
//                             <Paper
//                                 variant="outlined"
//                                 sx={{
//                                     p: 3,
//                                     height: '100%',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     textAlign: 'center',
//                                     transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
//                                     '&:hover': {
//                                         transform: 'translateY(-5px)',
//                                         boxShadow: 3,
//                                     },
//                                 }}
//                             >
//                                 <Box color="primary.main" sx={{ mb: 2 }}>
//                                     {React.cloneElement(service.icon, { sx: { fontSize: 40 } })}
//                                 </Box>
//                                 <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
//                                     {service.title}
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1, mb: 2 }}>
//                                     {service.description}
//                                 </Typography>
//                                 <Button variant="outlined" size="small">
//                                     Learn More
//                                 </Button>
//                             </Paper>
//                         </Grid>
//                     ))}
//                 </Grid>

//                 {/* --- Our Process Section --- */}
//                 <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
//                     <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 5 }}>
//                         Our Simple Process
//                     </Typography>
//                     <Grid container spacing={4}>
//                         {processSteps.map((step) => (
//                             <Grid item xs={12} md={4} key={step.title}>
//                                 <Box>
//                                     <Box color="primary.main" sx={{ mb: 2 }}>
//                                         {React.cloneElement(step.icon, { sx: { fontSize: 50 } })}
//                                     </Box>
//                                     <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
//                                         {step.title}
//                                     </Typography>
//                                     <Typography variant="body1" color="text.secondary">
//                                         {step.description}
//                                     </Typography>
//                                 </Box>
//                             </Grid>
//                         ))}
//                     </Grid>
//                 </Box>

//                 {/* --- Call to Action (CTA) Section --- */}
//                 <Paper
//                     sx={{
//                         p: { xs: 3, md: 5 },
//                         textAlign: 'center',
//                         backgroundColor: 'primary.main',
//                         color: 'white',
//                     }}
//                 >
//                     <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>
//                         Ready to Grow Your Brand?
//                     </Typography>
//                     <Typography variant="h6" sx={{ mb: 3, opacity: 0.9 }}>
//                         Let's work together to take your business to the next level. Contact us for a free consultation.
//                     </Typography>
//                     <Button
//                         variant="contained"
//                         size="large"
//                         sx={{
//                             backgroundColor: 'white',
//                             color: 'primary.main',
//                             '&:hover': { backgroundColor: '#f4f6f8' },
//                         }}
//                     >
//                         Get a Free Consultation
//                     </Button>
//                 </Paper>

//             </Container>
//         </Box>
//     );
// };

// export default Services;

import React from "react";
import { Box, Container, Grid, Paper, Typography, Button } from "@mui/material";
import {
    People, TrendingUp, Analytics, VideoLibrary, Campaign, Search,
    Create, BarChart, Group, Web, ThumbUp, Share
} from "@mui/icons-material";

// --- Data for the page sections ---
const servicesList = [
    { title: "Social Media Management", description: "Complete management of your social media profiles.", icon: <People /> },
    { title: "SEO Optimization", description: "Improve your search engine rankings and visibility.", icon: <TrendingUp /> },
    { title: "Content Creation", description: "Engaging video, graphic, and written content.", icon: <VideoLibrary /> },
    { title: "Analytics & Reporting", description: "Detailed performance insights and reports.", icon: <Analytics /> },
    { title: "Advertising Campaigns", description: "Targeted social media advertising strategies.", icon: <Campaign /> },
    { title: "Keyword Research", description: "Strategic keyword analysis to find your audience.", icon: <Search /> },
    { title: "Content Strategy", description: "Strategic content planning for maximum impact.", icon: <Create /> },
    { title: "Performance Metrics", description: "Comprehensive analytics tracking and KPIs.", icon: <BarChart /> },
    { title: "Community Management", description: "Engage, grow, and nurture your audience.", icon: <Group /> },
    { title: "Website Optimization", description: "Technical SEO improvements for better performance.", icon: <Web /> },
    { title: "Engagement Boost", description: "Increase audience interaction and loyalty.", icon: <ThumbUp /> },
    { title: "Social Sharing", description: "Maximize your content's reach and virality.", icon: <Share /> },
];

const processSteps = [
    { title: "1. Discovery", description: "We start by researching your brand, goals, and target audience.", icon: <Search /> },
    { title: "2. Strategy", description: "Next, we create a custom-tailored strategy designed to meet your unique needs.", icon: <Create /> },
    { title: "3. Growth", description: "We execute the plan and provide transparent reports on your growth.", icon: <TrendingUp /> },
];


// --- The Main Component ---
const Services = () => {
    return (
        <Box sx={{ backgroundColor: "#f4f6f8", py: { xs: 4, md: 8 } }}>
            <Container maxWidth="lg">

                {/* --- Hero Section --- */}
                <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
                    <Typography variant="h2" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Our Services
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '700px', mx: 'auto' }}>
                        We offer a comprehensive suite of digital marketing services designed to elevate your brand's online presence and drive measurable results.
                    </Typography>
                </Box>

                {/* --- Services Grid --- */}
                <Grid container spacing={3} sx={{ mb: { xs: 6, md: 10 } }}>
                    {servicesList.map((service) => (
                        // THIS IS THE FIX: Added sx={{ display: 'flex' }} to the Grid item
                        <Grid item xs={12} sm={6} md={3} key={service.title} sx={{ display: 'flex' }}>
                            <Paper
                                variant="outlined"
                                sx={{
                                    p: 3,
                                    width: '100%', // Ensure paper takes full width of the grid item
                                    display: 'flex',
                                    flexDirection: 'column',
                                    textAlign: 'center',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-5px)',
                                        boxShadow: 3,
                                    },
                                }}
                            >
                                <Box color="primary.main" sx={{ mb: 2 }}>
                                    {React.cloneElement(service.icon, { sx: { fontSize: 40 } })}
                                </Box>
                                <Typography 
                                    variant="h6" 
                                    sx={{ fontWeight: 'bold', mb: 1 }}
                                >
                                    {service.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1, mb: 2 }}>
                                    {service.description}
                                </Typography>
                                <Button variant="outlined" size="small">
                                    Learn More
                                </Button>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                {/* --- Our Process Section --- */}
                <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
                    <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 5 }}>
                        Our Simple Process
                    </Typography>
                    <Grid container spacing={4}>
                        {processSteps.map((step) => (
                            <Grid item xs={12} md={4} key={step.title}>
                                <Box>
                                    <Box color="primary.main" sx={{ mb: 2 }}>
                                        {React.cloneElement(step.icon, { sx: { fontSize: 50 } })}
                                    </Box>
                                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                                        {step.title}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        {step.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* --- Call to Action (CTA) Section --- */}
                <Paper
                    sx={{
                        p: { xs: 3, md: 5 },
                        textAlign: 'center',
                        backgroundColor: 'primary.main',
                        color: 'white',
                    }}
                >
                    <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Ready to Grow Your Brand?
                    </Typography>
                    <Typography variant="h6" sx={{ mb: 3, opacity: 0.9 }}>
                        Let's work together to take your business to the next level. Contact us for a free consultation.
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        sx={{
                            backgroundColor: 'white',
                            color: 'primary.main',
                            '&:hover': { backgroundColor: '#f4f6f8' },
                        }}
                    >
                        Get a Free Consultation
                    </Button>
                </Paper>

            </Container>
        </Box>
    );
};

export default Services;